module.exports = __webpack_public_path__ + "img/empresas_pago_por_link.7f658ca8.svg";